/**
 * Temporary stopgap function for promoted specialties due to the api
 * migration solution being projected to take longer than the time
 * we have to get topnav exp out.
 *
 * Does two things:
 * 1. Adds a topNavTitle field for changed titles for specific speicalties,
 *    components should use the topNavTitle FOR DISPLAY ONLY IFF topnavexp is on.
 * 2. Changes the order of the specialties.
 */

import { SearchPromotionItem } from '../common/components/SearchHeader/Suggestions/EmptySearchSuggestions/SearchPromotionResponse.type';

const specialtyOrder = [
  'Telehealth',
  'General Practice',
  'Dentistry',
  'Physiotherapy',
  'Chiropractic',
  'Podiatry',
  'Psychology',
  'Audiology',
  'COVID-19 Vaccinations',
  'Flu Vaccinations',
  'Optometry',
  'Counselling',
  'Skin Cancer',
  'COVID-19 Testing',
  'Radiology',
];

export const transformPromotedSpecialtiesForTopNavExp = (
  specialties: SearchPromotionItem[],
): SearchPromotionItem[] => {
  const orderedSpecialties: SearchPromotionItem[] = specialties.sort(
    (a, b) => specialtyOrder.indexOf(a.title) - specialtyOrder.indexOf(b.title),
  );

  const transformedSpecialties: SearchPromotionItem[] = [];

  for (const specialty of orderedSpecialties) {
    const transformedSpecialty: SearchPromotionItem = convertSpecialty(specialty);
    transformedSpecialties.push(transformedSpecialty);
  }

  return transformedSpecialties;
};

const convertSpecialty = (specialty: SearchPromotionItem): SearchPromotionItem => {
  let topNavTitle = specialty.title;

  switch (specialty.title) {
    case 'Telehealth':
      topNavTitle = 'GP Telehealth';
      break;
    case 'General Practice':
      topNavTitle = 'GP In-Person';
      break;
    case 'Dentistry':
      topNavTitle = 'Dental';
      break;
    case 'Physiotherapy':
      topNavTitle = 'Physio';
      break;
    case 'Chiropractic':
      topNavTitle = 'Chiropractor';
      break;
    case 'COVID-19 Vaccinations':
      topNavTitle = 'COVID Vaccine';
      break;
    case 'Flu Vaccinations':
      topNavTitle = 'Flu Vaccine';
      break;
  }

  return {
    ...specialty,
    topNavTitle: topNavTitle,
  };
};
